var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-full flex-container"},[_c('search-nav',{attrs:{"defaultValue":_vm.params.keyword,"placeholder":"请输入商品名称/商品编码/关键字"},on:{"searchFunc":_vm.searchFunc}}),_c('div',{staticClass:"flex-scroll"},[_c('goods-list',{ref:"goodsList",attrs:{"isKeyword":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }